var React = require('react');

function Fan (props) {
    return React.createElement("svg",props,[React.createElement("defs",{"key":0},React.createElement("style",null,".fa-secondary{opacity:.4}")),React.createElement("path",{"d":"M352.57 128c-28.09 0-54.09 4.52-77.06 12.86l12.41-123.11C289 7.31 279.81-1.18 269.33.13 189.63 10.13 128 77.64 128 159.43c0 28.09 4.52 54.09 12.86 77.06L17.75 224.08C7.31 223-1.18 232.19.13 242.67c10 79.7 77.51 141.33 159.3 141.33 28.09 0 54.09-4.52 77.06-12.86l-12.41 123.11c-1.05 10.43 8.11 18.93 18.59 17.62 79.7-10 141.33-77.51 141.33-159.3 0-28.09-4.52-54.09-12.86-77.06l123.11 12.41c10.44 1.05 18.93-8.11 17.62-18.59-10-79.7-77.51-141.33-159.3-141.33zM256 292a36 36 0 1 1 36-36 36 36 0 0 1-36 36z","className":"fa-secondary","key":1}),React.createElement("path",{"d":"M256 292a36 36 0 1 1 36-36 36 36 0 0 1-36 36z","className":"fa-primary","key":2})]);
}

Fan.defaultProps = {"viewBox":"0 0 512 512","className":"icon"};

module.exports = Fan;

Fan.default = Fan;
